/* eslint-disable react/prop-types */
import { GetAccount200ResponsePositionsInner } from "../../codegen-api";
import { usePositionTpslDisplay } from "../../hooks/tpsl/useTpslDisplay";
import { PositionCardTpsl } from "./style";

interface IPositionCardTpslValueProps {
  position: GetAccount200ResponsePositionsInner;
  positionId: string;
  /**
   * The instrument's price precision. Previously omitted here, so the card
   * formatted triggers at currency.js's default 2 decimals while the desktop and
   * mobile surfaces used the instrument's own — the same trigger rendered with a
   * different number of decimals depending on viewport width.
   */
  pricePrecision: number;
  /** Omitted on chains without a TP/SL executor — then this is read-only. */
  onEdit?: (positionId: string) => void;
}

/**
 * TP/SL summary on the tablet/phone position card. Tapping it opens the
 * TP/SL modal where the feature is available. Lookup and formatting are shared
 * with the desktop cell and the mobile row via usePositionTpslDisplay.
 */
function PositionCardTpslValue({
  position,
  positionId,
  pricePrecision,
  onEdit,
}: IPositionCardTpslValueProps) {
  const { takeProfitLabel, stopLossLabel } = usePositionTpslDisplay(
    position,
    pricePrecision
  );

  return (
    <PositionCardTpsl
      as={onEdit ? "button" : "div"}
      $interactive={Boolean(onEdit)}
      onClick={
        onEdit
          ? (event: React.MouseEvent) => {
              event.stopPropagation();
              onEdit(positionId);
            }
          : undefined
      }
    >
      TP/SL{" "}
      <span>
        {takeProfitLabel} / {stopLossLabel}
      </span>
    </PositionCardTpsl>
  );
}

export default PositionCardTpslValue;
